<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="mb-0">
      <template #prepend>
        <v-icon icon="mdi-home" size="small"/>
      </template>
    </v-breadcrumbs>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card rounded="xl" elevation="2">
            <div class="tabs-wrapper">
              <!-- Tabs -->
              <div ref="tabsContainer" class="tabs-scroll">
                <v-tabs v-model="tab" color="primary" :touch="false" hide-slider="false"  next-icon="mdi-arrow-right-bold-box-outline"
                        prev-icon="mdi-arrow-left-bold-box-outline"
                        show-arrows>
                  <v-tab value="personal">ব্যক্তিগত</v-tab>
                  <v-tab value="passport">পাসপোর্ট</v-tab>
                  <v-tab value="disabled">ক্ষুদ্র নৃ-গোষ্ঠী/প্রতিবন্ধী</v-tab>
                  <v-tab value="language">ভাষা</v-tab>
                  <v-tab value="bank">ব্যাংক</v-tab>
                  <v-tab value="photo">ছবি</v-tab>
                  <v-tab value="signature">স্বাক্ষর</v-tab>
                </v-tabs>
              </div>
            </div>

            <v-divider />

            <!-- IMPORTANT -->
            <!-- touch="false" stops swipe changing -->
            <v-window v-model="tab" :touch="false">
              <v-window-item value="personal">
                <v-card-text>
                  <PersonalInfoComponent />
                </v-card-text>
              </v-window-item>
              <v-window-item value="passport">
                <v-card-text>
                  <PassportComponent />
                </v-card-text>
              </v-window-item>

              <v-window-item value="disabled">
                <v-card-text>
                  <DisabledComponent />
                </v-card-text>
              </v-window-item>

              <v-window-item value="language">
                <v-card-text>
                  <LanguageComponent />
                </v-card-text>
              </v-window-item>

              <v-window-item value="bank">
                <v-card-text>
                  <BankComponent />
                </v-card-text>
              </v-window-item>

              <v-window-item value="photo">
                <v-card-text>
                  <PhotoComponent />
                </v-card-text>
              </v-window-item>

              <v-window-item value="signature">
                <v-card-text>
                  <SignatureComponent />
                </v-card-text>
              </v-window-item>

            </v-window>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/* Components */
import PersonalInfoComponent from "@/components/pages/PMIS/PersonalInformation/Personal.vue"
import PassportComponent from "@/components/pages/PMIS/PersonalInformation/Passport.vue"
import DisabledComponent from "@/components/pages/PMIS/PersonalInformation/Disabled.vue"
import LanguageComponent from "@/components/pages/PMIS/PersonalInformation/Language.vue"
import BankComponent from "@/components/pages/PMIS/PersonalInformation/Bank.vue"
import PhotoComponent from "@/components/pages/PMIS/PersonalInformation/Photo.vue"
import SignatureComponent from "@/components/pages/PMIS/PersonalInformation/Signature.vue"

export default {
  name: "PersonalInformation",
  components: {
    PersonalInfoComponent,
    PassportComponent,
    DisabledComponent,
    LanguageComponent,
    BankComponent,
    PhotoComponent,
    SignatureComponent
  },
  data() {
    return {
      /* Active Tab */
      tab: 'personal',
      /* Breadcrumb */
      breadcrumbs: [
        {
          title: "Dashboard",
          disabled: false,
          to: "/dashboard",
        },
        {
          title: "Personal Information",
          disabled: true,
        }
      ]
    }
  },
  methods: {
    scrollTabs(direction) {
      const container = this.$refs.tabsContainer
      if (!container) return
      const scrollAmount = 250
      container.scrollBy({
        left: direction === 'right' ? scrollAmount : -scrollAmount,
        behavior: 'smooth',
      })
    },
  }
}
</script>

<style scoped>
.v-tabs {
  background: transparent;
}
.v-tab {
  font-size: 14px;
}
.v-tab.v-tab.v-btn {
  font-size: 16px;
  text-shadow: 0px 0px 1px black;
}
.tabs-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

/* Scroll Area */
.tabs-scroll {
  overflow-x: auto;
  flex: 1;
  scrollbar-width: none;
}

.tabs-scroll::-webkit-scrollbar {
  display: none;
}

/* Prevent tabs wrap */
:deep(.v-slide-group__content) {
  flex-wrap: nowrap;
}

/* Arrow Buttons */
.arrow-btn {
  flex-shrink: 0;
  z-index: 2;
  background: white;
}

.left-arrow {
  margin-right: 4px;
}

.right-arrow {
  margin-left: 4px;
}
</style>